<label class="col-lg-4 col-form-label text-end">{{label}}
	<i class="fa fa-question-circle margin-left-xs"
			revTooltip
			[allowHtml]="true"
			[tooltipContent]="tooltip">
	</i>
</label>
